import { useState } from 'react';

import { api } from '../api.js';
import Modal from './Modal.jsx';

const STATUSES = ['offen', 'bezahlt', 'storniert'];

/**
 * Modal zum Anlegen oder Bearbeiten einer Rechnung.
 *
 * Props:
 *  - mandantId: Mandant, dem die Rechnung gehört (für POST)
 *  - initial?: bestehende Rechnung zum Bearbeiten (mit id), sonst neu
 *  - onClose: () => void
 *  - onSaved: () => Promise|void
 */
export default function InvoiceFormModal({ mandantId, initial, onClose, onSaved }) {
    const editing = initial && initial.id !== undefined;
    const today = new Date().toISOString().slice(0, 10);

    const [invoiceNo, setInvoiceNo] = useState(initial?.invoice_no ?? '');
    const [date, setDate] = useState(initial?.date ?? today);
    const [amount, setAmount] = useState(
        initial?.amount !== undefined ? String(initial.amount) : ''
    );
    const [status, setStatus] = useState(initial?.status ?? 'offen');
    const [description, setDescription] = useState(initial?.description ?? '');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setSaving(true);
        setError('');
        try {
            const payload = {
                invoice_no: invoiceNo || null,
                date: date || null,
                amount: amount === '' ? 0 : Number(amount.replace(',', '.')),
                status,
                description: description || null,
            };
            if (editing) {
                await api.updateInvoice(initial.id, payload);
            } else {
                await api.createInvoice({ ...payload, mandant_id: mandantId });
            }
            await onSaved();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    }

    return (
        <Modal
            title={editing ? 'Rechnung bearbeiten' : 'Neue Rechnung'}
            onClose={onClose}
            footer={
                <>
                    <button type="button" className="btn" onClick={onClose}>Abbrechen</button>
                    <button type="submit" form="invoice-form" className="btn btn--primary" disabled={saving}>
                        {saving ? 'Speichere…' : 'Speichern'}
                    </button>
                </>
            }
        >
            <form id="invoice-form" onSubmit={handleSubmit}>
                {error && <div className="login__error">{error}</div>}
                <div className="grid-2">
                    <div className="field">
                        <label>Rechnungsnummer</label>
                        <input type="text" value={invoiceNo} onChange={(e) => setInvoiceNo(e.target.value)} />
                    </div>
                    <div className="field">
                        <label>Datum</label>
                        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                    </div>
                </div>
                <div className="grid-2">
                    <div className="field">
                        <label>Betrag (€)</label>
                        <input
                            type="text"
                            inputMode="decimal"
                            placeholder="0,00"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </div>
                    <div className="field">
                        <label>Status</label>
                        <select value={status} onChange={(e) => setStatus(e.target.value)}>
                            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                        </select>
                    </div>
                </div>
                <div className="field">
                    <label>Beschreibung</label>
                    <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
                </div>
            </form>
        </Modal>
    );
}
